import { render, staticRenderFns } from "./course-list-item-more.vue?vue&type=template&id=7baa1833&"
import script from "./course-list-item-more.vue?vue&type=script&lang=js&"
export * from "./course-list-item-more.vue?vue&type=script&lang=js&"
import style0 from "./course-list-item-more.vue?vue&type=style&index=0&id=7baa1833&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports